import { Component, OnInit } from '@angular/core';
import { ApplicationStateService } from '../../../services/application-state.service';
import { QuickLinkService } from '../../../services/quick-link.service';
import { QuickLink, QuickLinkType } from '../../../models/quick-link';
import { PageService } from '../../../services/page.service';
import { cloneDeep } from 'lodash-es';
import { CommunicationService } from '../../../services/communication.service';
import { SidebarContentComponent } from '../sidebar/sidebar-content-component';
import { AssetPipe } from '../../../pipes/asset.pipe';
import { WorksheetService } from '../../../services/worksheet.service';
import { Worksheet } from '../../../models/worksheet';
import { WorksheetItemComponent } from './worksheet-item/worksheet-item.component';

@Component({
    selector: 'app-sidebar-tasks-worksheet',
    templateUrl: './worksheets.component.html',
    styleUrls: ['./worksheets.component.scss'],
    standalone: true,
    imports: [
        AssetPipe,
        WorksheetItemComponent
    ]
})
export class WorksheetsComponent implements OnInit, SidebarContentComponent {
    quicklink: QuickLink;
    teacherToolActive = false;
    worksheets: Array<Worksheet>;

    constructor(
        public applicationStateService: ApplicationStateService,
        private quicklinkService: QuickLinkService,
        private pageService: PageService,
        private communicationService: CommunicationService,
        private worksheetService: WorksheetService
    ) {
        this.communicationService.worksheetChangeSourceAnnounced$.subscribe(() => {
            this.worksheetService.getWorksheets()
                .then(result => {
                    this.worksheets = result;
                })
        });
    }

    ngOnInit() {
        this.setQuicklink();

        this.worksheetService.getWorksheets()
            .then(result => {
                this.worksheets = result;
            });

        this.communicationService.pageTurnConfirmed$.subscribe(() => {
            this.setQuicklink();
        });
    }

    openWorksheetEditor() {
        if (!this.quicklink) {
            return;
        }

        const clonedQuicklink = cloneDeep(this.quicklink);
        clonedQuicklink.isSignable = true;
        const combinedLink = this.quicklinkService.getCombinedLinkAndTmpRedirect(
            clonedQuicklink.link
        );
        clonedQuicklink.combinedLink = combinedLink?.combinedLink;
        clonedQuicklink.tmpRedirect = combinedLink?.tmpRedirect;
        clonedQuicklink.bypassCheck =
            this.applicationStateService.bookConfig.bookPermissions.calcuflowLinks.use;
        clonedQuicklink.type = QuickLinkType.CALCUFLOW;
        this.quicklinkService.openQuicklink(clonedQuicklink);
    }

    private setQuicklink(): void {
        this.quicklink = null;
        this.teacherToolActive = false;

        const secondPage = this.pageService.getCurrentPages().length > 1;
        this.quicklink = this.quicklinkService.getFirstQuickLinkOfPageAndType(
            this.pageService.getCurrentPages()[0].id,
            QuickLinkType.HSM
        );
        if (!this.quicklink && secondPage) {
            this.quicklink = this.quicklinkService.getFirstQuickLinkOfPageAndType(
                this.pageService.getCurrentPages()[1].id,
                QuickLinkType.HSM
            );
        }

        if (this.quicklink) {
            this.quicklinkService.fetchAssignmentData(this.quicklink.slug).then((result) => {
                this.teacherToolActive = !!result?.feature?.teachertool;
            });
        }
    }
}
